var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Cart")]),(_vm.cart.length > 0)?_c('div',[_c('CartList',{attrs:{"cart":_vm.cart}})],1):_c('div',[_c('p',[_vm._v("cart is empty")])])])}
var staticRenderFns = []

export { render, staticRenderFns }